import type {OrderFormState, AppConfig} from '../../../types'

const stateToNddContacts = (formState: OrderFormState, config: AppConfig) => {
  const phones = [formState.ndd?.route?.source?.phone, formState.ndd?.route?.destination?.phone]
    .filter(Boolean)
    .filter(phone => (phone ? config.checkIsValidPhone?.(phone) ?? true : false))
  if (phones.length === 0) {
    return null
  }
  return phones.map((phone, index) => ({
    phone: config.normalizePhone?.(phone.startsWith('+') ? phone : `+${phone}`) ?? phone,

    route_index: index,
  }))
}

const stateToPickupPoints = (formState: OrderFormState) => {
  const source = formState.ndd?.route?.source?.pickupPoint
  const destination = formState.ndd?.route?.destination?.pickupPoint

  if (!source && !destination) {
    return null
  }

  return [
    source
      ? {
          station_id: source?._id,
          type: 'source',
          full_text: source?.name,
          coordinates: source?.coordinates || [source?.position?.longitude, source?.position?.latitude],
        }
      : null,
    destination
      ? {
          station_id: destination?._id,
          type: 'destination',
          full_text: destination?.name,
          coordinates: destination?.coordinates || [destination?.position?.longitude, destination?.position?.latitude],
        }
      : null,
  ].filter(Boolean)
}

export const mapToNddFields = (formState: OrderFormState, config: AppConfig) => ({
  pickup_points: stateToPickupPoints(formState),
  contacts: stateToNddContacts(formState, config),
  package_size: formState.package_size,
  offer_name: null,
  taxi_classes: null,
})
